import React, { useState, useEffect, useCallback, useRef } from "react";
import styled from "styled-components";

interface ITextareaProps {
  text: string;
  onChange(text: string): void;
  placeholder?: string;
  id?: string;
  className?: string;
}

const TextareaV2 = (props: ITextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [countNum, setCountNum] = useState(0);

  useEffect(() => {
    if (textareaRef === null || textareaRef.current === null) {
      return;
    }
    textareaRef.current.style.height = "400px";
    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      setCountNum(textareaRef.current.defaultValue.length);
    }
  }, [textareaRef.current]);

  const handleResizeHeight = useCallback(() => {
    if (textareaRef === null || textareaRef.current === null) {
      return;
    }
    textareaRef.current.style.height = "400px";
    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    window.scrollTo(0, textareaRef.current.scrollHeight);
  }, []);

  const handleCount = (e: HTMLTextAreaElement) => {
    const content = e.value;
    setCountNum(content.length);
    if (content.length > 1000) {
      alert("최대 1000자까지 입력 가능합니다.");
      if (textareaRef === null || textareaRef.current === null) {
        return;
      }
      textareaRef.current.value = content.substring(0, 1000);
      setCountNum(1000);
    }
  };

  return (
    <TextareaSet className={props.className}>
      <textarea
        ref={textareaRef}
        value={props.text}
        onChange={(e) => props.onChange(e.currentTarget.value)}
        onInput={handleResizeHeight}
        onKeyUp={(e) => handleCount(e.currentTarget)}
        placeholder={props.placeholder}
        id={props.id}
      />
      <div className="count">
        <span>{countNum}</span>/1000
      </div>
    </TextareaSet>
  );
};

const TextareaSet = styled.div`
  position: relative;
  padding-top: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  margin-top: 16px;
  > textarea {
    display: block;
    overflow: hidden;
    width: 100%;
    min-height: 400px;
    padding-bottom: 30px;
    border: none;
    color: ${({ theme }) => theme.color.primary};
    font-family: "Roboto";
    font-size: 16px;
    line-height: 20px;
    resize: none;
    box-sizing: border-box;
    &::placeholder {
      color: rgba(0, 24, 39, 0.4);
      font-size: 16px;
      font-family: "Roboto";
      font-weight: 500;
    }
    &:focus {
      outline: none;
    }
  }
  .count {
    z-index: 10;
    position: absolute;
    right: 8px;
    bottom: 8px;
    color: ${({ theme }) => theme.color.tertiary};
  }
`;

export default TextareaV2;
